/**
 * The product name shared by every runtime surface.
 *
 * Keep this as the single source of truth when rebranding the application.
 */
export const APP_NAME = 'Belore' as const;
